module.exports = __webpack_public_path__ + "img/escuchas_pelea.e4b7c51e.webp";